import { render, staticRenderFns } from "./StudipActionMenu.vue?vue&type=template&id=365b9cf2&"
import script from "./StudipActionMenu.vue?vue&type=script&lang=js&"
export * from "./StudipActionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports